"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicVideoCardsService = void 0;
const tslib_1 = require("tslib");
const queries_1 = require("./queries");
const mappers_1 = require("./mappers");
const guid_1 = require("../../utils/guid");
const base_public_service_1 = require("../base-public-service");
class PublicVideoCardsService extends base_public_service_1.BasePublicService {
    getList(videoId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.request(queries_1.GET_VIDEO_CARD_QUERY, {
                videoId,
            });
            const cards = resp.video.cards.entities.map((card) => (0, mappers_1.mapGqlCardToOldCard)(card, { clientId: (0, guid_1.guid)() }));
            return { data: cards };
        });
    }
}
exports.PublicVideoCardsService = PublicVideoCardsService;
//# sourceMappingURL=video-cards.js.map